exports = module.exports = require("../../../../../../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".CartTotal_total{font-size:100%;display:flex;justify-content:space-between}.CartTotal_total_amount{text-align:right}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAIE,iBACE,cAAA,CACA,YAAA,CACA,6BAAA,CAEA,wBACE,gBAAA","file":"styles.scss","sourcesContent":["$theme: zam;\n@import \"../../../../../../scss/variables.scss\";\n\n.CartTotal {\n  &_total {\n    font-size: 100%;\n    display: flex;\n    justify-content: space-between;\n\n    &_amount {\n      text-align: right;\n    }\n  }\n}\n"]}]);

// Exports
exports.locals = {
	"colorPrimary": "#4ca94d",
	"CartTotal_total": "CartTotal_total",
	"CartTotal_total_amount": "CartTotal_total_amount"
};